/* All links */

$('a').each(function() {
  if(~$(this).attr('href')?.indexOf('//') && !$(this).closest('.language-choose')?.length && $(this).attr('href') != 'https://shopify.ecom-store.pro') {
    $(this).attr('target', '_blank');
  } else {
    $(this).attr('rel', '');
  }
});


/* Scroll to Contact form Success message */

$(function() {
  if(~window.location.href.indexOf('contact_posted=true') && $('.contact-form .form-success').length) {
    let elem = $('.contact-form .form-success');
    if(elem.length) {
      let elemTop = elem.offset().top;
      let headerHeight = $('.header-container').height();
      $([document.documentElement, document.body]).animate({
        scrollTop: (elemTop - headerHeight - 15)
      }, 1000);
      return false;
    }
  }
});


/* Page: Platforms tabs */

$('.platform-tabs > h3').on('click', function() {
  if(!$(this).hasClass('active')) {
    
    $('.platform-tabs > h3').removeClass('active');
    $(this).addClass('active');
    
    var index = $(this).index();
    $('.platform-tabs > ol').slideUp(500);
    $('.platform-tabs > ol').each(function(i) {
      if(i == index) $(this).slideDown(500);
    });
    
  }
});



/* Article page */

$(function() {
  let articleSection = $('.template-article article');
  let articleBannerSection = $('.template-article .hero-banner-final');
  if(articleSection.length) {

    $('.template-article .affiliate-disclosure > *').on('click', function() {
      $('.partnership-info .desc').toggleClass('active');
    });
    $('.template-article .affiliate-disclosure .desc').on('click', function(e) {
      e.stopPropagation();
    });
    $('body').on('click', function(e) {
      let close = true;
      if($(e.target).hasClass('affiliate-disclosure') ||
         $(e.target).closest('.affiliate-disclosure').length
         ) close = false;
      if(close) $('.template-article .partnership-info .desc').removeClass('active');
    });
    
    $('.sticky-contents-button').on('click', function() {
      $('body').addClass('show-menu');
    });
    $('.sticky-contents-menu .close').on('click', function() {
      $('body').removeClass('show-menu');
    });
    $('body').on('click', function(e) {
      if(!$(e.target).hasClass('sticky-contents-menu') && 
         !$(e.target).closest('.sticky-contents-menu').length &&
         !$(e.target).hasClass('sticky-contents-button')) {
        $('body').removeClass('show-menu');
      }
    });
    $('.sticky-contents-menu .contents-item a').on('click', function() {
      if($(window).width() < 1346) $('.sticky-contents-menu .close').trigger('click');
    });
    $('.show-all-contents .arrow').on('click', function() {
      $(this).closest('.contents').addClass('opened');
    });
    
    let section = $('.template-article article > .grid > .grid__item > .rte--indented-images');
    let mainContents = $('.template-article article .contents');
    let stickyContentsButton = $('.sticky-contents-button');
    
	let documentHeight = $(document).height();   
	let windowHeight = $(window).height();
    let windowTop = $(window).scrollTop();
    let headerHeight = $('.header-container.sticky').height();
    if(headerHeight) windowTop += headerHeight + 25;
    let windowBottom = windowTop + windowHeight;
    
    $(window).on('scroll', function() {
      windowTop = $(window).scrollTop();
      headerHeight = $('.header-container.sticky').height();
      if(headerHeight) windowTop += headerHeight + 25;
      windowBottom = windowTop + windowHeight;
      
      // To mark the Contents headings
      section.find('h2, h3, h4').each(function() {
        let blockPosition = $(this).offset().top;
        if(blockPosition > windowTop && blockPosition < windowBottom) {
          let id = $(this).attr('id');
          if(id && !~id.indexOf('instruction-point')) {
            $('.sticky-contents-menu .contents .contents-item a').removeClass('bold');
            $('.sticky-contents-menu .contents .contents-item a[href="#'+id+'"]').addClass('bold');
          }
          return false;
        }
      });
      
      // Show / hide the Contents button
      if(mainContents.length && stickyContentsButton.length) {
        let mainContentsPosition = mainContents.offset().top + mainContents.height();
        if(mainContentsPosition < windowTop) stickyContentsButton.addClass('to-show');
        else stickyContentsButton.removeClass('to-show');
      }

      // Include Vistia Video script
      if($('.wistia_responsive_wrapper').length && vistiaIncluded == false) {
        let vistiaVisible = false;
        $('.wistia_responsive_wrapper').each(function() {
	      let thisOffest = $(this).offset().top;
	      let thisHeight = $(this).outerHeight();
	      if(windowTop + windowHeight >= thisOffest) {
            vistiaVisible = true;
          }
    	});
        if(vistiaVisible) {
          vistiaIncluded = true;
          let wistiaScript = document.createElement('script');
          wistiaScript.src = 'https://fast.wistia.com/assets/external/E-v1.js';
          wistiaScript.async = true;
          document.head.appendChild(wistiaScript);
        }
      }
      
    });
    
    
    /* Скролл из оглавления */
    
    $('.contents .contents-item a').on('click', function() {
      let elem = $($(this).attr('href'));
      if(elem.length) {
        let elemTop = elem.offset().top;
        let headerHeight = $('.header-container.sticky').height();
        $([document.documentElement, document.body]).animate({
          scrollTop: (elemTop - headerHeight - 25)
        }, 0);
        return false;
      }
    });


    /* Секция "Плюсы и минусы" */

    $('.article-pros-and-cons thead tr th').on('click', function() {
      let tableEl = $(this).closest('table');
      if($(this).hasClass('show-all')) {
        if(tableEl.hasClass('show-all')) {
          $(this).siblings('th:first-child').trigger('click');
          tableEl.find('tbody .title').removeClass('active');
          tableEl.find('.desc').hide();
        }
        else {
          tableEl.addClass('show-all');
          tableEl.find('.title').addClass('active');
          tableEl.find('.desc').show();
          tableEl.find('tbody td').addClass('active');
          tableEl.find('thead th').removeClass('active');
        }
      }
      else {
        tableEl.removeClass('show-all');
        $(this).addClass('active');
        $(this).siblings('th').removeClass('active');
        let curIndex = $(this).index() + 1;
        tableEl.find('tbody td:nth-child('+curIndex+')').addClass('active');
        tableEl.find('tbody td:nth-child('+curIndex+')').siblings('td').removeClass('active');
      }
    });
    $('.article-pros-and-cons table tbody .title').on('click', function() {
      $(this).toggleClass('active');
      $(this).next('.desc').slideToggle();
    });


    /* Табы на странице курсов */
    
    $('article .tabs .tab').on('click', function() {
      if($(this).hasClass('active')) return false;
      $(this).siblings('.tab').removeClass('active');
      $(this).addClass('active');
      var openArea = $(this).data('open');
      $(this).closest('.tabs').siblings('.content-area').removeClass('active');
      $(this).closest('.tabs').siblings('.content-area.'+openArea).addClass('active');
    });


    /* Responsive tables */

    let artileTables = document.querySelectorAll('article .rte table');
    artileTables.forEach(function(table) {
      let parentEl = table.parentNode;
      if(!parentEl.classList.contains('responsive-table') && !parentEl.classList.contains('article-pros-and-cons')) {
        $(table).wrap("<div class='responsive-table'></div>");
      }
    });
    
  }
  

  /* Add Wistia script */

  let vistiaIncluded = false;
  if($('.wistia_responsive_wrapper').length && vistiaIncluded == false) {
    
    let vistiaVisible = false;
	  let windowHeight = $(window).height();
    let windowTop = $(window).scrollTop();
    let headerHeight = $('.header-container.sticky').height();
    if(headerHeight) windowTop += headerHeight + 25;
    let windowBottom = windowTop + windowHeight;
    
    $('.wistia_responsive_wrapper').each(function() {
      let thisOffest = $(this).offset().top;
      let thisHeight = $(this).outerHeight();
      if(windowTop + windowHeight >= thisOffest) {
        vistiaVisible = true;
      }
    });
    if(vistiaVisible) {
      vistiaIncluded = true;
      let wistiaScript = document.createElement('script');
      wistiaScript.src = 'https://fast.wistia.com/assets/external/E-v1.js';
      wistiaScript.async = true;
      document.head.appendChild(wistiaScript);
      
      // For Course page
      $('body').on('click', '.wistia_responsive_padding.waiting', function() {
        if(!$(this).hasClass('waiting')) return;
        let videoId = $(this).data('video-id');
        if(videoId) {
          window._wq = window._wq || [];
          _wq.push({
            id: videoId,
            options: {
              plugin: {
                "captions-v1": {
                  onByDefault: true,
                  language: 'eng'
                }
              }
            },
            onReady: function(video) {
              if(!video?.plugin?.captions?.options?.onByDefault) {
                video.plugin['captions-v1'].turnOn();
              }
              video.play();
              setTimeout(function() {
                $(video.container).removeClass('hide-it');
              }, 500);
            }
          });
          $(this).closest('.top-image').addClass('custom-padding');
        }
        
        $(this).removeClass('waiting');

        let lessonsSelect = $('.lessons-nav select');
        if(!lessonsSelect.val()) {
          let firstOption = lessonsSelect.find('option:nth-child(2)');
          lessonsSelect.val(firstOption.val());
        }
        
      });
      
    }
  }
  
    
/* Блог "Курсы Шопифай" */
  
  // Центрирование высоты заголовков
  
  let itemsInLine = 3;
  if($(window).width() < 1050) itemsInLine = 2;
  else if ($(window).width() < 591) itemsInLine = 1;
  let maxHeight = 0;
  if($(window).width() > 590) {
    $('.featured-blog').each(function() {
      const $elems = $(this).find('article.article-course, .featured-blog__post__grid');
      $elems.each(function() {
        let index = $(this).index() + 1;
        let header = $(this).find('.article-excerpt .h3, .title');
        let headerHeight = header.height();
        if(headerHeight > maxHeight) maxHeight = headerHeight;
        if((index % itemsInLine) == 0) {
          header.height(maxHeight);
          $(this).prev().find('.article-excerpt .h3, .title').height(maxHeight);
          if(itemsInLine == 3) $(this).prev().prev().find('.article-excerpt .h3, .title').height(maxHeight);
          maxHeight = 0;
        }
        else if(index == $elems.length) {
          header.height(maxHeight);
          if((index % itemsInLine) != 1) {
            $(this).prev().find('.article-excerpt .h3, .title').height(maxHeight);
          }
          maxHeight = 0;
        }
      });
    });
  }
  
  
  // Открытие меню тем
  
  $('.template-blog .sidebar-humburger').on('click', function() {
    $('.blog-handle-shopify-courses sidebar.sidebar').addClass('slide-on');
  });
  $('.template-blog .sidebar .close').on('click', function() {
    $(this).closest('.sidebar').removeClass('slide-on');
  });
  $('.blog-handle-shopify-courses .sidebar .head-2 .tab-toggle').on('click', function() {
    $(this).toggleClass('active');
    $(this).closest('.title').siblings('.head-3').slideToggle();
  });
  
});



/* Email Notifications Translation */

/*
$(function() {
  if(typeof NotifTranslationBase == 'object') {
    $('.email-notif-translate > div.left button.btn').on('click', function() {
      var nativeNotif = $('.email-notif-translate textarea.native').val();
      if(nativeNotif.length) {
        var nativeHtml = $.parseHTML(nativeNotif);
        if(nativeHtml) {
          $(nativeHtml).find('*').each(function() {
            var elemText = $.trim($(this).text());
            for(var i = 0; i < NotifTranslationBase.length; i++) {
              if(NotifTranslationBase[i].en == elemText) {
                nativeNotif = nativeNotif.replaceAll(elemText, NotifTranslationBase[i].ru);
              }
            }
          });
        }
        for(var i = 0; i < NotifTranslationBase.length; i++) {
          if(~nativeNotif.indexOf(NotifTranslationBase[i].en)) {
            nativeNotif = nativeNotif.replaceAll(NotifTranslationBase[i].en, NotifTranslationBase[i].ru);
          }
        }
        $('.email-notif-translate .right textarea').text(nativeNotif);
        $('.email-notif-translate .right .btn').attr('disabled', false);
      }
    });
    $('.email-notif-translate > div.right button.btn').on('click', function() {
      var copyTextarea = document.querySelector('.email-notif-translate > div.right textarea');
      copyTextarea.focus();
      copyTextarea.select();
      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
      } catch (err) {
        
      }
      this.focus();
    });
  }
});
*/



/* Sticky Header */

$(function() {
  
  let header = $('#shopify-section-header .header-container');
  
  if($('body').hasClass('template-index')) {
    let topBanner = $('#PageContainer #shopify-section-slideshow:nth-child(2)');
    if(topBanner.length) {
      let topBannerHeight = topBanner.height();
      $(window).on('scroll', function() {
        topBannerHeight = topBanner.height();
        let topOffset = window.pageYOffset;
        if(topOffset > topBannerHeight) header.addClass('sticky');
        else header.removeClass('sticky');
      });
    }
  }
  else {
    let headerHeight = header.outerHeight();
    let preHeader = $('#shopify-section-header .pre-header-container');
    header.addClass('sticky');
    preHeader.height(headerHeight);
  }
  
});


/* Mobile navigation */

$(function() {
  $('.mobile-nav__has-sublist > a').on('click', function() {
    $(this).siblings('.mobile-nav__toggle').find('.mobile-nav__toggle-btn').trigger('click');
    return false;
  });
});


/* Language selection */

$(function() {
  $('body').on('click', function(e) {
    if(!$(e.target).closest('.language-selector').length) $('.language-choose')?.removeClass('active');
  });
});


/* Shopify prices page */

$(function() {
  $('body.handle-shopify-prices-and-plans table tbody td:first-child').on('click', function() {
    if($(window).width() < 769) {
      $(this).toggleClass('active');
      $(this).siblings('td').slideToggle();
    }
  });
  
  $('body.handle-shopify-prices-and-plans .main-content a').on('click', function() {
    let href = $(this).attr('href');
    if(!~href.indexOf('http') && ~href.indexOf('#')) {
      let elem = $('body.handle-shopify-prices-and-plans .main-content '+ href);
      if(elem.length) {
        let elemTop = elem.offset().top;
        let headerHeight = $('.header-container.sticky').height();
        $([document.documentElement, document.body]).animate({
          scrollTop: (elemTop - headerHeight - 25)
        }, 0);
        return false;
      }
    }
  });
});


/* Header Announcement bar close */

$(function() {
  $('.announcement-bar').slideDown();
  $('.announcement-bar .close').on('click', function(e) {
    e.stopPropagation();
    e.preventDefault();
    $(this).closest('.announcement-bar').slideUp();
    window.sessionStorage.setItem('top-bar-close', 'yes');
  });
});


/* Footer */

$(function() {
  $('.site-footer .grid-uniform .menu-item .title').on('click', function() {
    if($(window).width() <= 768) {
      $(this).toggleClass('active');
      $(this).siblings('.site-footer__linklist').slideToggle();
    }
  })
})